// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__3ZmN_","contained":"OpenButton_contained__3JCUn","disabled":"OpenButton_disabled__3llql","error":"OpenButton_error__2WaeB"};